export const navLinks = [
  { label: "评论区", icon: "ri-chat-3-line", href: "#comments" },
  { label: "话题广场", icon: "ri-hashtag", href: "#topics" },
  { label: "关注与私信", icon: "ri-user-follow-line", href: "#follow" },
  { label: "下载客户端", icon: "ri-download-2-line", href: "#download" },
  { label: "社区规范", icon: "ri-shield-check-line", href: "#rules" },
];

export const heroPoints = [
  "评论即时同步，追评不丢楼层",
  "关注后追踪发帖动态",
  "私信仅对话双方可见",
  "每条内容都可一键举报",
];

export const boardStats = [
  { icon: "ri-user-3-line", value: "12,486", label: "当前在线用户", trend: "较昨日 +4.2%" },
  { icon: "ri-edit-2-line", value: "3,204", label: "今日新发帖子", trend: "较昨日 +8.6%" },
  { icon: "ri-hashtag", value: "1,890", label: "活跃话题标签", trend: "本周新增 214" },
  { icon: "ri-mail-send-line", value: "28,650", label: "今日私信送达", trend: "平均回复 6 分钟" },
];

export const entryItems = [
  {
    icon: "ri-chat-3-line",
    tone: "primary",
    title: "评论区直达",
    desc: "进入任意话题即可发言、追评、@ 其他用户，讨论痕迹全程保留。",
    action: "进入评论区",
    href: "#comments",
  },
  {
    icon: "ri-hashtag",
    tone: "accent",
    title: "话题广场",
    desc: "按标签浏览当日热度最高的话题墙，快速找到正在讨论的那一条。",
    action: "逛话题广场",
    href: "#topics",
  },
  {
    icon: "ri-user-follow-line",
    tone: "secondary",
    title: "关注动态",
    desc: "关注感兴趣的作者后，新帖与追评第一时间推送到你的首页动态流。",
    action: "查看关注流",
    href: "#follow",
  },
  {
    icon: "ri-mail-send-line",
    tone: "primary",
    title: "私信信箱",
    desc: "与爆料人一对一沟通，交换线索、补齐凭证、核实细节，无需公开。",
    action: "打开信箱",
    href: "#follow",
  },
  {
    icon: "ri-shield-check-line",
    tone: "secondary",
    title: "举报与申诉",
    desc: "发现不实内容或隐私泄露，一键提交人工复核，进度可在站内查看。",
    action: "提交举报",
    href: "#rules",
  },
  {
    icon: "ri-download-2-line",
    tone: "accent",
    title: "下载客户端",
    desc: "移动端接收关注与私信实时提醒，评论区体验与网页端完全同步。",
    action: "立即下载",
    href: "#download",
  },
];

export const topicRanks = [
  { rank: "01", name: "今日爆料集中讨论贴", count: "2.4 万讨论", trend: "up" },
  { rank: "02", name: "消费避坑与维权经验", count: "1.8 万讨论", trend: "up" },
  { rank: "03", name: "职场见闻与签约细节", count: "1.2 万讨论", trend: "steady" },
  { rank: "04", name: "网络热点求证现场", count: "9,640 讨论", trend: "down" },
  { rank: "05", name: "租房与二手交易踩坑", count: "7,320 讨论", trend: "up" },
];

export const topicTags = [
  { name: "#今日爆料", count: "2.4 万", tone: "hot" },
  { name: "#围观现场", count: "1.6 万", tone: "hot" },
  { name: "#消费避坑", count: "1.8 万", tone: "accent" },
  { name: "#维权记录", count: "9,210", tone: "plain" },
  { name: "#职场见闻", count: "1.2 万", tone: "secondary" },
  { name: "#网络热点求证", count: "8,470", tone: "plain" },
  { name: "#租房踩坑", count: "7,320", tone: "plain" },
  { name: "#二手交易", count: "5,880", tone: "secondary" },
  { name: "#粉丝动向", count: "6,140", tone: "accent" },
  { name: "#数码翻车", count: "4,260", tone: "plain" },
  { name: "#探店实测", count: "3,970", tone: "plain" },
  { name: "#旅途见闻", count: "3,180", tone: "secondary" },
  { name: "#校园话题", count: "2,760", tone: "plain" },
  { name: "#情感吐槽", count: "2,410", tone: "plain" },
  { name: "#居家生活", count: "1,930", tone: "plain" },
  { name: "#健身与饮食", count: "1,240", tone: "plain" },
];

export const commentThreads = [
  {
    id: "c1",
    topic: "#消费避坑",
    topicHref: "#topics",
    user: "隔壁老陈",
    initial: "陈",
    tone: "primary",
    time: "12 分钟前",
    content:
      "上周在同一家门店踩了坑，沟通记录和凭证我都整理好了。正文不贴图，需要的在评论区留言或者私信我，我看到就会回。",
    likes: 328,
    replies: [
      { user: "小满", initial: "满", content: "求一份凭证，我这边情况几乎一样，先关注你了。" },
      { user: "阿亮", initial: "亮", content: "等你的后续更新，评论区不吵架真好。" },
    ],
  },
  {
    id: "c2",
    topic: "#网络热点求证",
    topicHref: "#topics",
    user: "夜航船",
    initial: "夜",
    tone: "accent",
    time: "35 分钟前",
    content:
      "同一个视频有两个剪辑版本，我比对了一晚上，建议先别急着下结论，等当事人自己回应。我把时间线整理在评论第二楼了。",
    likes: 512,
    replies: [
      { user: "围观甲", initial: "甲", content: "时间线很清楚，比只看片段靠谱多了。" },
      { user: "路过的猫", initial: "猫", content: "已经转发给群里了，让大家都看完整版。" },
      { user: "小柯", initial: "柯", content: "补充一句：原始文件的时间戳也对得上。" },
    ],
  },
  {
    id: "c3",
    topic: "#职场见闻",
    topicHref: "#topics",
    user: "林间风",
    initial: "林",
    tone: "secondary",
    time: "1 小时前",
    content:
      "关于调休的说法，我打听了一圈，结论和主贴里写的不完全一样。我把能公开讲的三点补充在下面，涉及具体公司的部分就不展开。",
    likes: 196,
    replies: [
      { user: "老周", initial: "周", content: "理性补充，这种帖子才值得追。" },
    ],
  },
];

export const followSteps = [
  {
    step: "01",
    icon: "ri-add-circle-line",
    title: "关注感兴趣的作者",
    desc: "在帖子卡片或评论区点一下关注，系统会把这位作者加入你的关注列表，不需要先加好友。",
  },
  {
    step: "02",
    icon: "ri-notification-3-line",
    title: "追踪发帖与追评动态",
    desc: "关注之后，作者的新帖、置顶追评和话题更新会出现在首页动态流，按时间顺序排列，不会漏掉后续。",
  },
  {
    step: "03",
    icon: "ri-mail-send-line",
    title: "私信沟通线索与求证",
    desc: "想深入聊就打开私信：交换线索、补充凭证、确认细节。对话只保存在双方信箱里，不会出现在公开评论区。",
  },
];

export const rules = [
  {
    icon: "ri-user-heart-line",
    title: "发言留痕，文明表达",
    desc: "可以对线、可以质疑，但请针对事实而不是针对人。辱骂、人身攻击与骚扰会被折叠并记录。",
    tone: "primary",
  },
  {
    icon: "ri-search-eye-line",
    title: "未经核实不扩散",
    desc: "把「听说」和「已核实」分开放。拿不出凭证的内容，我们会打上待核实标记，提醒其他人先别转发。",
    tone: "accent",
  },
  {
    icon: "ri-lock-2-line",
    title: "守住隐私红线",
    desc: "真实姓名、住址、手机号、证件照等隐私信息一律不允许公开发布，发现即删除并限制相关账号。",
    tone: "secondary",
  },
  {
    icon: "ri-shield-check-line",
    title: "举报与人工复核",
    desc: "每条帖子和评论都有举报入口，提交后会进入人工复核队列，处理结果同步给举报人。",
    tone: "primary",
  },
];

export const faqs = [
  {
    id: "f1",
    q: "黑料社区的评论区怎么参与互动？",
    a: "注册并登录后，进入任意话题或帖子即可在评论区发言。你可以直接评论、回复指定用户、给楼层点赞，也能把某条评论转发到私信里继续聊。评论与回复会按时间顺序保留，随时可以翻回去看完整脉络。",
  },
  {
    id: "f2",
    q: "关注之后会收到什么动态？",
    a: "关注一位作者后，他发布的新帖、置顶的追评以及参与的话题更新，都会出现在首页的关注动态流中，按时间排序。你可以在动态流里直接点开继续看评论区，也可以对动态做「稍后再看」标记。",
  },
  {
    id: "f3",
    q: "私信可以用来做什么？",
    a: "私信适合不适合公开讨论的内容：交换线索、补充凭证、核实细节、跟进后续。私信对话只在双方信箱中保存，不会出现在公开评论区；如果对方后续公开了内容，你也可以把私信里的结论整理成评论发出去。",
  },
  {
    id: "f4",
    q: "不想被打扰，可以关闭私信吗？",
    a: "可以。在隐私设置里把私信权限改为「仅互相关注的人可发」或「关闭」，改动即时生效。历史私信不会被删除，只是新的对话请求不会送达。",
  },
  {
    id: "f5",
    q: "遇到不实内容或者隐私泄露怎么办？",
    a: "每条帖子和评论都带举报入口，选择对应的原因提交即可进入人工复核队列。涉及隐私泄露的内容会优先处理并立即下线；处理结果会通过站内通知同步给举报人。",
  },
];

export const footerColumns = [
  {
    title: "功能入口",
    links: [
      { label: "评论区", href: "#comments" },
      { label: "话题广场", href: "#topics" },
      { label: "关注与私信", href: "#follow" },
      { label: "下载客户端", href: "#download" },
    ],
  },
  {
    title: "社区支持",
    links: [
      { label: "常见问题", href: "#faq" },
      { label: "社区规范", href: "#rules" },
      { label: "举报与申诉", href: "#rules" },
      { label: "隐私设置说明", href: "#faq" },
    ],
  },
  {
    title: "关于社区",
    links: [
      { label: "社区介绍", href: "#top" },
      { label: "互动数据看板", href: "#board" },
      { label: "联系我们", href: "#top" },
      { label: "加入我们", href: "#top" },
    ],
  },
];